import { c as _c } from "react/compiler-runtime";
import { SvgIcon, SvgIconProps } from '@mui/material';
const CCNCIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M7.982 0.072c-0.068 0-0.133-0.002-0.201 0-4.272 0.108-7.71 3.612-7.71 7.91 0 4.367 3.544 7.91 7.91 7.91s7.91-3.544 7.91-7.91-3.544-7.91-7.91-7.91zM7.773 1.432c0.070-0.002 0.138 0 0.209 0 3.616 0 6.551 2.935 6.551 6.551 0 0.623-0.087 1.226-0.25 1.797l-3.854-1.737c-0.031-0.043-0.065-0.084-0.101-0.123-0.301-0.329-0.873-0.608-1.716-0.839-0.751-0.205-1.127-0.358-1.272-0.461-0.144-0.098-0.216-0.222-0.216-0.371 0-0.166 0.079-0.301 0.236-0.403 0.157-0.107 0.351-0.16 0.722-0.16 0.589 0 0.948 0.036 1.429 0.441l0.854-0.928c-0.441-0.523-1.279-0.742-1.98-0.793v-1.151h-0.803v1.165c-0.552 0.064-0.99 0.245-1.313 0.543-0.278 0.258-0.451 0.584-0.534 0.965l-3.271-1.474c1.13-1.763 3.081-2.952 5.311-3.022zM7.982 14.533c-3.616 0-6.551-2.935-6.551-6.551 0-0.787 0.139-1.543 0.395-2.242l4.247 1.914c0.028 0.026 0.057 0.053 0.089 0.080 0.312 0.269 1.075 0.633 2.174 0.939l0.649 0.292c0.066 0.057 0.119 0.11 0.151 0.144 0.079 0.085 0.118 0.203 0.118 0.352 0 0.218-0.049 0.538-0.245 0.649-0.534 0.302-2.089 0.251-2.598-0.462l-0.993 0.914c0.307 0.545 1.259 0.89 2.162 1.007v1.14h0.803v-1.098c0.738-0.036 1.264-0.353 1.696-0.755 0.335-0.309 0.549-0.679 0.641-1.109l3.019 1.36c-1.11 2.040-3.273 3.425-5.757 3.425z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon viewBox="0 0 16 16" {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default CCNCIcon;